"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * All supported rdeTypes have to be listed here with corresponding abbreviations for their reco type
 * Abbreviation will be used by GTM like "box_{{abbr}}_reco"
 * Possible in the future:
 * "rde" (Prudsys), "alt" (alternative Articles), "ser" (series), "cat" (category recommendations), ...
 *
 * When you add a new rdeType it has to be considered in the file ./Functions/getQueryArguments.ts, too
 */
exports.rdeTypes = {
    alternativeProducts: 'alt',
    criteoProducts: 'crit',
    lastSeenProducts: 'ls',
    outfit: 'out',
    productsSimilar: 'aa',
    productsComplementary: 'kem',
    prudSysAddToBasket: 'rde',
    prudsysCategoryToBrands: 'brand',
    prudsysCategoryToBrandsPapi: 'brand_papi',
    prudsysCategoryToCategories: 'cat',
    prudsysCategoryToCategoriesPapi: 'cat_papi',
    prudsysCategoryToProductsPapi: 'rde_papi',
    prudsysHomePage: 'rde',
    prudSysProducts: 'rde',
    prudSysProductsSimilar: 'rde_similar',
    prudSysSearchTerm: 'rde',
    prudsysUserToProductsPapi: 'rde_papi',
    seriesProducts: 'ser',
};
//# sourceMappingURL=types.js.map